import React from "react";
import "./Tile.css";
import Particles from "reactparticles.js";
import { Button } from "reactstrap";

function Tab(props) {
  return (
    <div className="Tile">
      <Particles id={props.id} config={props.config} style={props.style} />
      <br />
      <Button href={props.config} download color="info">
        Download config
      </Button>
      <br />
    </div>
  );
}

export default Tab;
